import { render, staticRenderFns } from "./XCurrencyTextField.vue?vue&type=template&id=595b8f77"
import script from "./XCurrencyTextField.vue?vue&type=script&lang=js"
export * from "./XCurrencyTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports